import { useState } from "react";
import { CardTitle } from "../../ui/text/CardTitle/CardTitle";
import { BorderWrap } from "../../ui/wrappers/BorderWrap/BorderWrap";
import "./CollectionItem.css";
import { TextButton } from "../../ui/buttons/TextButton/TextButton";
import { useAppSelector } from "../../../services/hooks/useAppHooks";
import { useDeleteCollectionMutation } from "../../../store/collections/collectionsApi";
import { Collection } from "../../../services/types/collection.type";
import { ItemMenu } from "../../ui/ItemMenu/ItemMenu";

interface CollectionItemProps {
  item: Collection;
  editAction: (uuid: string) => void;
  updatePage: () => void;
}

export const CollectionItem = ({
  item,
  editAction,
  updatePage,
}: CollectionItemProps) => {
  const { user } = useAppSelector((state) => state.auth);
  const [showMenu, setShowMenu] = useState(false);
  const [deleteCollection] = useDeleteCollectionMutation();

  const menuClick = () => {
    setShowMenu((showMenu) => !showMenu);
  };

  const editItem = () => {
    editAction(item.uuid);
    setShowMenu(false);
  };

  const deleteItem = async () => {
    if (window.confirm("Вы действительно хотите удалить этоту коллекцию?")) {
      try {
        await deleteCollection(item.uuid).unwrap();
        updatePage();
      } catch (err) {
        console.error("Ошибка удаления коллекции", err);
      }
    }
  };

  return (
    <BorderWrap>
      <ItemMenu showMenu={showMenu} menuClick={menuClick}>
        <TextButton text="Редактировать" action={editItem} />
        {user && (user.role === "admin" || user.role === "superadmin") ? (
          <TextButton text="Удалить" margin="1rem 0 0 0" action={deleteItem} />
        ) : (
          <></>
        )}
      </ItemMenu>
      <CardTitle title={item.name} margin="1rem 0 0" />
    </BorderWrap>
  );
};
